import { render, staticRenderFns } from "./DemoConfigShowConfigurationCard.vue?vue&type=template&id=783edf9e"
import script from "./DemoConfigShowConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./DemoConfigShowConfigurationCard.vue?vue&type=script&lang=ts"
import style0 from "./DemoConfigShowConfigurationCard.vue?vue&type=style&index=0&id=783edf9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports